var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LineChart',{ref:"chart",attrs:{"unit":_vm.unit,"scale":_vm.scale,"title":_vm.widgettitle,"daterange":_vm.daterange,"loading":_vm.loading}})
}
var staticRenderFns = []

export { render, staticRenderFns }